/// ----------------------------------------------------------------------------------------
///Copyright (C) 2017 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>azure-ad-access-token-refresh.service.ts</name>
///
/// <description>
/// A service that wakes up a few minutes before access token expiration
/// and calls authz-api to get a token with extended expiration
/// Azure AD blog: http://www.cloudidentity.com/
/// </description>
///
/// <author>Yaron Habot</author>
/// <created>9 May 2017</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 09Aug17 YH  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
///
import { Injectable } from '@angular/core';
import { Http, Response, Headers,RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HydUser } from '../../models/user';
import {LogService} from '../../services/log.service';
import { HydrogenAppConfigService } from '../../host.config.service';
import 'rxjs/add/observable/interval';
import { Subscription } from 'rxjs/Subscription';
import { MediatorService } from '../../services/mediator.service';
import { MediatorEventLookup } from '../../services/mediator-event-lookup.service';


@Injectable()
export class AzureADAccessTokenRefreshService {

    private config: any;
    private tokenRefreshStateNonce: string;
    private refreshTimerSubcscription:Subscription=null;
    private refreshTimer:any;
  private isBrowserRefreshed: boolean = false;

    //----------------------------------------------------------
    //constructor
    //----------------------------------------------------------
  constructor(
      private http:Http,
      private hydUser: HydUser,
      private logService : LogService,
      private configSvc: HydrogenAppConfigService,
      private mediator:MediatorService
    )
  {
      this.config = this.configSvc.config;

      //MM - Timing issue, may not catch the event if initialized AFTER the event is fired...
      //this.resetRefreshTimer();

      //Subscribe to HydUser authentication event and start an interval to fetch a refreshed access token
      let inst = this;
      this.hydUser.AuthorizationObservable.subscribe(
          authorized=> {
            if (authorized) {

              if (this.refreshTimerSubcscription) {
                this.refreshTimerSubcscription.unsubscribe();
                this.refreshTimerSubcscription = null;
              }
              this.isBrowserRefreshed=false;
                //Refresh the token if there are 2 more minutes to the access token expiration

              //For Fusion, refresh token every 15 mins.. 
              let intervalms: number = 900000;//this.hydUser.TokenExpirationEpoch*1000 -  Date.now() - 120000;
                //If something went wrong and the interval is less then 0, then set the interval to 2 minutes
                if (intervalms <0)
                    intervalms = 120000;
                inst.logService.logMessage("AzureADAccessTokenRefreshService user authenticated. Start refresh interval of "+intervalms+" ms");
               this.refreshTimer=null;
               this.refreshTimer = Observable.interval(intervalms);
               this.refreshTimerSubcscription=this.refreshTimer.subscribe(x=>inst.getRefreshTokenFromAuthorizationService());
            }
          }
      );
  }


    //----------------------------------------------------------
    //getRefreshTokenFromAuthorizationService
    //----------------------------------------------------------
  private getRefreshTokenFromAuthorizationService() {
      this.logService.logMessage("AzureADAccessTokenRefreshService getRefreshTokenFromAuthorizationService()");

      this.tokenRefreshStateNonce = this.createNonce();

      var url;
      if(!this.configSvc.config.UseB2C) {
          var authority = this.config.azureAD.SecureTokenServer + this.config.azureAD.Tenant + this.config.azureAD.OAuth2Token;
          url = this.config.serviceUrl["authz"] + "/api/authorization/refresh" +
                  "?authority=" + encodeURIComponent(authority) +
                  "&userId=" + encodeURIComponent(this.hydUser.UserId) +
                  "&resource=" + this.config.azureAD.AADHydrogenAuthorizationServiceId +
                  "&state=" + this.tokenRefreshStateNonce +
                  "&refreshToken=" +this.hydUser.RefreshToken;
        } else {
          var authority = this.config.azureB2C.SecureTokenServer + this.config.azureB2C.Tenant + this.config.azureB2C.OAuth2Token;
          url = this.config.serviceUrl["authz"] + "/api/authorization/refresh" +
                      "?authority=" + encodeURIComponent(authority) +
                      "&userId=" + encodeURIComponent(this.hydUser.UserId) +
                      "&resource=" + this.config.azureB2C.AADHydrogenAuthorizationServiceId +
                      "&state=" + this.tokenRefreshStateNonce +
                      "&refreshToken=" +this.hydUser.RefreshToken;
        }                
    console.debug(url);
    //YH 1/19/2017 Fix for Firefox. Spell out to pesky FF that it should accept a json
    let headers = new Headers({ 'Accept': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    this.http.get(url,options)
        .map((res:Response) => res.json())
        .subscribe(
            dataJson => {
                //this.logService.logMessage("AzureADAccessTokenRefreshService.getRefreshTokenFromAuthorizationService() response="+dataJson);

                let data = JSON.parse(dataJson);
                let accessTokenPayload = this.parseJwt(data.AccessToken);
                this.hydUser.RefreshAccessToken("bearer "+data.AccessToken,data.RefreshToken,accessTokenPayload.exp);
                this.logService.logMessage("AzureADAccessTokenRefreshService.getRefreshTokenFromAuthorizationService() accessToken="+data.AccessToken);
                this.logService.logMessage("AzureADAccessTokenRefreshService.getRefreshTokenFromAuthorizationService() refreshToken="+data.RefreshToken);
                this.logService.logMessage("AzureADAccessTokenRefreshService.getRefreshTokenFromAuthorizationService() expiration="+accessTokenPayload.exp);

                if(this.isBrowserRefreshed)
                {
                  this.setRefreshTimer();
                  this.isBrowserRefreshed=false;
                }

            },
            err => {

            },
            () => {//console.log('GetAccessTokenFromAuthorizationService done')
            }
        );

  }

    //----------------------------------------------------------
    //resetRefreshTimer
    //----------------------------------------------------------
    public resetRefreshTimer()
    {
      let inst=this;
      this.mediator.Event(MediatorEventLookup.RefreshToken).subscribe(
        payload=>{

          if (this.hydUser.isLoggedIn) {
              inst.isBrowserRefreshed = true; 
              inst.getRefreshTokenFromAuthorizationService(); 
          }
        }
      )
  }

  //----------------------------------------------------------
  //setRefreshTimer
  //----------------------------------------------------------
  private setRefreshTimer()
  {
    if (this.refreshTimerSubcscription) {
      this.refreshTimerSubcscription.unsubscribe();
      this.refreshTimerSubcscription = null;
    }

    let interval = 900000;//this.hydUser.TokenExpirationEpoch*1000 -  Date.now() - 120000;
    if (interval <0)
        interval = 120000;

    this.refreshTimer=null;
    this.refreshTimer = Observable.interval(interval);
    this.refreshTimerSubcscription=this.refreshTimer.subscribe(x=>this.getRefreshTokenFromAuthorizationService());
  }

    //----------------------------------------------------------
    //createNonce
    //----------------------------------------------------------
    private createNonce() {
        let nonce = "";
        let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (let i = 0; i < 32; i++) {
            nonce += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return nonce;
    }


    //----------------------------------------------------------
    //parseJwt
    //----------------------------------------------------------
    private parseJwt(token:string) {
        if (token)
        {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace('-', '+').replace('_', '/');
            return JSON.parse(window.atob(base64));
        }
        return null;
    };

}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/authentication/azure-active-directory/azure-ad-access-token-refresh.service.ts